









import Vue from 'vue'
import Component from 'vue-class-component';
import { State } from 'vuex-class';
import { DashButton } from '@/store/types';
import LoadingScreen from '@/modules/core/LoadingScreen';
import {Carousel, Slide} from 'vue-carousel';
import {GridItem, GridLayout} from 'vue-grid-layout';
import WidgetBoard from '@/modules/widget/components/WidgetBoard.vue';
import Omnisearch from '@/modules/omnisearch/components/Omnisearch.vue';

@Component({
    components: {
        Omnisearch,
        Carousel, Slide, GridLayout, GridItem, WidgetBoard,
    },
})
export default class Dashboard extends Vue {
    @State
    public dashButtons: DashButton[]

    public layout = [
        {name: 'widget 1', x: 0, y: 0, h: 2, w: 2, i: 0},
        {name: 'widget 2', x: 1, y: 0, h: 2, w: 2, i: 1},
        {name: 'widget 2', x: 2, y: 0, h: 2, w: 2, i: 2},
    ]
    public created () {
        this.$store.commit('showToolbar')
        this.$store.commit('showSidenav')
        LoadingScreen.hide();
    }
}
